import { Suspense } from "react";
import {
  Await,
  LoaderFunction,
  NonIndexRouteObject,
  Outlet,
  useLoaderData,
} from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { forwardAuth } from "../../shared/utils/api.utils";
import { LoaderContext } from "../App.Parts";
import { FORWARD_AUTH_LAYOUT_ID, LoaderData } from "./ForwardAuth.Parts";

// LOADER
const ForwardAuthLoader: LoaderFunction<LoaderContext> = ({
  context,
}): LoaderData => {
  const forwardIfAuthenticated = async () => {
    const { authenticated } = (await context.auth) ?? {};
    if (authenticated) return await forwardAuth();
  };

  return { forwardIfAuthenticated: forwardIfAuthenticated() };
};

// WRAPPER
const ForwardAuthWrapper = () => {
  const { forwardIfAuthenticated } = useLoaderData<LoaderData>();

  return (
    <Suspense fallback={<LoadingSplash />}>
      <Await resolve={forwardIfAuthenticated} children={<Outlet />} />
    </Suspense>
  );
};

// LAYOUT
export const ForwardAuthLayout: NonIndexRouteObject = {
  id: FORWARD_AUTH_LAYOUT_ID,
  errorElement: <GeneralErrorPage />,
  Component: ForwardAuthWrapper,
  loader: ForwardAuthLoader,
};
